import { LearningStatus } from '@/core/domain/resources/enums/LearningStatus.ts'
import type { ILearningModuleRepository } from '@/core/domain/learning/module/ILearningModuleRepository.ts'
import type { LearningModule } from '@/core/domain/learning/module/LearningModule.ts'

export class UpdateLearningModuleStatusUseCase {
  private learningModuleRepository: ILearningModuleRepository

  constructor(learningModuleRepository: ILearningModuleRepository) {
    this.learningModuleRepository = learningModuleRepository
  }

  async execute(
    courseId: number,
    moduleId: number,
    status: LearningStatus.Values
  ): Promise<LearningModule> {
    return await this.learningModuleRepository.updateLearningModuleStatus(
      courseId,
      moduleId,
      status
    )
  }
}
